import React from "react";

const RecipeTiming = (props) => {
  //in the middle of converting using estimated prep time and cook time, to setting those times per each steps
  let hasCalculatedTimes = props.recipe?.total_time?.total_minutes > 0;
  let totalTime = hasCalculatedTimes
    ? props.recipe?.total_time?.total_minutes
    : props.recipe.prep_time + props.recipe.cook_time;
  let prepTime = hasCalculatedTimes
    ? props.recipe?.total_time?.breakdown?.prep
    : props.recipe.prep_time;
  let nonPrepTime = hasCalculatedTimes
    ? props.recipe?.total_time?.breakdown?.cook +
      props.recipe?.total_time?.breakdown?.bake +
      props.recipe?.total_time?.breakdown?.parallel
    : props.recipe.cook_time;

  return (
    <section className="Column p1">
      <div className="Row Space-E">
        <div className="Column A-Center">
          <h6>Prep Time</h6>
          <p>{prepTime} min</p>
        </div>
        <div className="Column A-Center">
          <h6>Cook/Bake Time</h6>
          <p>{nonPrepTime} min</p>
        </div>
      </div>
      <div className="Column A-Center">
        <h6>Total Time</h6>
        <p>{totalTime} min</p>
      </div>
    </section>
  );
};

export default RecipeTiming;
